<script setup lang="ts">
import { locale } from "../../../../locale";
import BasePopoverItem from "./BasePopoverItem.vue";
const props = defineProps<{
  close: () => void;
}>();
const copyLink = () => {
  if (navigator.clipboard.writeText) {
    navigator.clipboard.writeText(window.location.href);
  }
  props.close();
};
</script>
<template>
  <BasePopoverItem :text="locale.copymeet" @click.stop="copyLink">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 6.5L5.5 6.5C3.567 6.5 2 8.067 2 10V10C2 11.933 3.567 13.5 5.5 13.5H7.5M12.5 6.5L14.5 6.5C16.433 6.5 18 8.067 18 10V10C18 11.933 16.433 13.5 14.5 13.5H12.5M6 10H14"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </BasePopoverItem>
</template>
